import * as React from "react";
const SvgNeedle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 115 115 9", style: {
  stroke: "red",
  strokeWidth: 3
} }));
export default SvgNeedle;
